/**
 * Symbol used to track the original factory function for extensions.
 * This allows us to retrieve the original factory for comparison and other operations.
 */
export const originalFactorySymbol = Symbol("originalFactory");
